import {PersonLegalRoleVal} from '@modifi/enums'
import {PatchPersonIdentificationRequestView} from '@modifi/onboarding-api-clients'
import {pick} from 'ramda'
import {LEGAL_ROLE_PROPERTY_MAP} from './constants'

export const pickPropertyKeysByLegalRole = (
  legalRole: PersonLegalRoleVal,
  object: PatchPersonIdentificationRequestView
): Partial<PatchPersonIdentificationRequestView> => pick(LEGAL_ROLE_PROPERTY_MAP[legalRole], object)
